import { components } from 'react-select';
import { truncateText_v2 } from 'utils/common/String';

interface CustomMultiValueLabelProps {
  data: {
    label: string;
    value: string | number;
    color?: string;
  };
  [key: string]: any;
}

export const CustomMultiValueTagLabel = (props: CustomMultiValueLabelProps) => {
  const { data } = props;

  return (
    <components.MultiValueLabel {...props}>
      {truncateText_v2(data.label ? data.label : '', 20)}
    </components.MultiValueLabel>
  );
};
